<template>
  <div class="scroll_wrap">
    <div class="en_tit">{{caseData.info.en}}</div>
    <div class="scroll_tit">{{caseData.info.title}}</div>
    <div class="card_content gktp pc_container">
      <div class="center-box">
        <!-- caseData.list -->
        <div class="card" v-for="(item, index) in caseData.list" :key="index" @mouseenter="showMask(index)" @mouseleave="hideMask">
          <el-image :src="item.cover[0]" fit="cover" lazy />
          <div class="card_tit" :class="currentIndex === index ? 'active' : ''">{{ item.title }}</div>
          <div class="card_text" v-show="currentIndex === index" @click="$router.push({ path: '/news/detail', query: { id: item.id , type : item.category.slug }})">
            <div class="card_btn">查看详情</div>
            <img src="@/assets/images/project/icon_detail.png" alt="" class="icon" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    caseData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      currentIndex: null,
    }
  },
  methods: {
    showMask(index){
      this.currentIndex = index;
    },
    hideMask(){
      this.currentIndex = null;
    }
  },
}
</script>

<style lang="scss" scoped>
.scroll_wrap {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 30px;
  text-align: center;
  background: #f6f6f6;

  .en_tit {
    font-family: SourceHanSansCN-Bold;
    font-size: 48px;
    color: #DCDCDC;
    text-transform: uppercase;
  }

  .scroll_tit {
    font-family: SourceHanSansCN-Bold;
    font-size: 36px;
    color: #000;
    margin-top: -15px;
    position: relative;


    &::after {
      content: '';
      display: block;
      background: #000;
      margin: 0 auto;
      width: 60px;
      height: 5px;
      background: #006DE8;
      margin-top: 13px;
    }
  }

  .gktp {
    margin-top:30px;
    .center-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-content: space-between;
      .card {
        height: 387px;
        width: 459px;
        position: relative;
        border: 1px solid #E5E5E5;
        margin-bottom: 30px;
        .el-image {
          max-width: 100%;
          height: 314px;
          vertical-align: top;
        }
        .card_tit {
          font-size: 16px;
          font-family: SourceHanSansCN-Regular;
          height: 73px;
          line-height: 73px;
          background: #fff;
          overflow: hidden;
        }
        .active{
          background: #006DE8;
          color: #fff;
        }
        .card_text {
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 314px;
          background: rgba(0, 0, 0, .6);
          box-sizing: border-box;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          color: #fff;
          animation: fade-in-out 0.5s forwards; /* 应用动画 */

          .card_btn {
            font-size: 20px;
          }
          .icon{ 
            width: 50px;
            height: 50px;
            margin-top: 22px;
          }
        }
      }
    }
  }

  @keyframes fade-in-out {
      from {
          opacity: 0;
      }
      to {
          opacity: 1;
      }
  }

  @keyframes slide-down {
    to {
      top: 0; /* 动画结束时元素在原来位置 */
    }
  }
}
</style>